import notice from "../../utils/notice";
import { DASHBOARD_URL, BASE_URL_v2 } from "../helpers/routes";
import {
  getParams, getMultipartParams, handleResponse,
} from "../helpers/validate";

export const defaultDailyPick = {
  content: null,
  display_order: "",
};

export const getDashboardData = (
  date_from,
  date_to,
  team,
  month,
  mood,
  slug
) => {
  
  return fetch(
    `${DASHBOARD_URL}?${date_from ? `date_from=${date_from}&` : ""}${
      date_to ? `date_to=${date_to}&` : ""
    }${month ? `month=${month}&` : ""}${team ? `team=${team}&` : ""}${
      mood ? `mood=${mood}&` : ""
    }${slug ? `slug=${slug}` : ""}`,
    getMultipartParams("GET")
  )
    .then(handleResponse)
    .then((json) => {
      
      return json;
    })
    .catch((e) => {
      notice("Error fetching daily picks");
      console.error(e.errors);
    });
};

export const trackDashboardView = () => {
  fetch(
    `${BASE_URL_v2}/dashboard_views`,
    getParams("POST", JSON.stringify({ page_type: "home" }))
  ).catch(() => {
    // Fire-and-forget: silently ignore errors
  });
};
